module.exports = __webpack_public_path__ + "static/img/partner3.25c0896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner3.png
// module id = GUlf
// module chunks = 1